import React, { memo } from 'react';

import PropTypes from 'prop-types';

import { FieldTypesEnum } from 'constants/loanActionEditor';

import { wrapperClassname } from './LoanActionItem.constants';
import { DynamicValueInput } from './LoanActionItems';

const LoanActionExecuteAiProcessRow = ({ index, rootPath, isDisabled, isEditAllowed }) => {
  const fieldPath = `${rootPath}[${index}]`;

  return (
    <div className={wrapperClassname}>
      <DynamicValueInput
        required
        disabled={isDisabled || !isEditAllowed}
        label="AI Process ID"
        name={`${fieldPath}.processId`}
        type={FieldTypesEnum.STRING}
      />
      <DynamicValueInput
        disabled={isDisabled || !isEditAllowed}
        label="Include active certification"
        name={`${fieldPath}.includeActiveCertification`}
        type={FieldTypesEnum.BOOLEAN}
      />
    </div>
  );
};

LoanActionExecuteAiProcessRow.propTypes = {
  rootPath: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  isEditAllowed: PropTypes.bool.isRequired,
};

export default memo(LoanActionExecuteAiProcessRow);
